import React from 'react'
import { FlagProvider } from '@unleash/proxy-client-react'
import unleashClient from 'services/unleashClient'

export const FeatureFlagProvider = ({ children }) => {
  return <FlagProvider unleashClient={unleashClient()}>{children}</FlagProvider>
}
